import React from "react"
import { PrimaryHeadingTextImagesType } from "../../types/mainModulTypes"
import { API } from "../../constants/constants"
import { HashLink } from "react-router-hash-link"
import BaseSubheadline from "../common/BaseSubheadline"
import BaseRichtext from "../common/BaseRichtext"

export default function PrimaryHeadingTextImages(props: PrimaryHeadingTextImagesType) {
    return (
        <div className="max-w-content-sm mx-auto text-center">
            <BaseSubheadline label={props.primaryHeadingTextImagesHeading} />
            <BaseRichtext content={props.primaryHeadingTextImageText} classProps="pt-2 pb-8" />
            <div className="flex justify-center items-center gap-8">
                {props?.primaryHeadingTextImagesImages.map((item, index) => (
                    <HashLink
                        to={item?.primaryHeadingTextImagesImagesItemUrl}
                        key={index}
                        className="border-8 border-primary w-full aspect-square relative rounded-default overflow-hidden">
                        <img
                            src={API + item?.primaryHeadingTextImagesImagesItemImage?.url}
                            alt={item?.primaryHeadingTextImagesImagesItemImage?.description + item.primaryHeadingTextImagesImagesItemImage.name}
                            className="w-full h-full object-cover "
                        />
                        {/* NOTE WOZU wichtig? nicht im Screenshot */}
                        <BaseSubheadline
                            classProps="font-medium absolute bottom-3 w-full text-center"
                            label={item?.primaryHeadingTextImagesImagesItemTitle}
                        />
                    </HashLink>
                ))}
            </div>
        </div>
    )
}
